import { PureComponent } from "react";
import styled from "styled-components";
import {
  Container,
  ContainerContentStandard,
} from "../../../shared/styles/container";
import { device } from "../../../shared/styles/device";
import Layout from "../components/global/Layout";
import Seo from "../components/global/Seo";

export const TextOnlyPageContainer = styled.div`
  min-height: 100vh;
  overflow: hidden;
  width: 100%;

  h1 {
    font-size: 48px;
    font-weight: 800;
    line-height: 78px;
    margin-top: 0;
  }
  h2,
  h3 {
    font-size: 20px;
    line-height: 43px;
    margin: 0;
    word-break: break-word;
  }

  p {
    color: ${(props) => props.theme.colors.fontBlack};
    margin-bottom: 32px;
    margin-top: 16px;
    font-size: 19px;
    line-height: 27px;
    font-weight: 500;
    letter-spacing: -0.01em;
    text-align: left;

    @media ${device.tablet} {
      font-size: 19px;
      line-height: 27px;
      font-weight: 500;
      letter-spacing: -0.01em;
    }
  }

  @media ${device.tablet} {
    h1 {
      font-size: 68px;
    }
    h2,
    h3 {
      font-size: 26px;
    }
  }

  section {
    margin-top: 64px;
  }
`;

export const Subheadline = styled.div`
  display: flex;
  flex-direction: row;
`;
export const WhiteLine = styled.div`
  background-color: ${(props) => props.theme.colors.primary};
  margin-right: 16px;
  min-width: 4px;
  @media ${device.tablet} {
    margin-right: 28px;
  }
`;
export const ContactGrid = styled.div`
  display: flex;
  flex-direction: column;
`;

export default class Kontakt extends PureComponent {
  render() {
    const title = "Kontakt";
    const description = "Kontakt";

    return (
      <>
        <Seo title={title} description={description} />
        <Layout preview={false}>
          <TextOnlyPageContainer>
            <Container>
              <ContainerContentStandard>
                <ContactGrid>
                  <div>
                    <h1>
                      Hast du Fragen? <br /> Dann melde dich bei uns!
                    </h1>
                    <Subheadline>
                      <WhiteLine />
                      <h2>Bewerber*innen</h2>
                    </Subheadline>
                  </div>
                  <p>
                    Hast du Fragen zum Event, zur Bewerbung, zum Talentpool oder
                    zum Ablauf am Speed-Recruiting-Tag?
                    <br />
                    Dann stell uns deine Fragen per Mail an hi@easyboarding.de.
                    <br />
                    Dringende Fragen kannst du uns gerne auch telefonisch unter
                    040 3890400 stellen
                  </p>
                  <section>
                    <div>
                      <Subheadline>
                        <WhiteLine />
                        <h2>Unternehmen</h2>
                      </Subheadline>
                    </div>
                    <p>
                      Die nächsten easyboarding-Events finden bald statt.
                      <br />
                      Für dieses in Präsenz geplante Events sind noch Plätze
                      frei.
                      <br /> Will Ihr Unternehmen mitmachen? Oder sind Sie auf
                      der Suche nach anderen Lösungen? Dann schreiben Sie uns an
                      hi@easyboarding.de.
                      <br /> Wir melden uns dann bei Ihnen mit allen
                      Informationen.
                    </p>
                  </section>
                </ContactGrid>
              </ContainerContentStandard>
            </Container>
          </TextOnlyPageContainer>
        </Layout>
      </>
    );
  }
}
